import { api } from '@/lib/api'
import type {
  AccessPolicy,
  AccessPolicyRequest,
  FieldDefinition,
  FieldRequest,
  FieldUpdateRequest,
  FormSchema,
  FormSection,
  SectionRequest,
  SectionUpdateRequest,
} from './types'

const base = (objectType: string) => `/api/forms/${objectType}`

export async function getFormSchema(objectType: string): Promise<FormSchema> {
  const res = await api.get<FormSchema>(`${base(objectType)}`)
  return res.data
}

export async function createSection(objectType: string, payload: SectionRequest): Promise<FormSection> {
  const res = await api.post<FormSection>(`${base(objectType)}/sections`, payload)
  return res.data
}

export async function updateSection(objectType: string, sectionCode: string, payload: SectionUpdateRequest): Promise<FormSection> {
  const res = await api.put<FormSection>(`${base(objectType)}/sections/${sectionCode}`, payload)
  return res.data
}

export async function deleteSection(objectType: string, sectionCode: string): Promise<void> {
  await api.delete(`${base(objectType)}/sections/${sectionCode}`)
}

export async function createField(objectType: string, payload: FieldRequest): Promise<FieldDefinition> {
  const res = await api.post<FieldDefinition>(`${base(objectType)}/fields`, payload)
  return res.data
}

export async function updateField(objectType: string, fieldCode: string, payload: FieldUpdateRequest): Promise<FieldDefinition> {
  const res = await api.put<FieldDefinition>(`${base(objectType)}/fields/${fieldCode}`, payload)
  return res.data
}

export async function deleteField(objectType: string, fieldCode: string): Promise<void> {
  await api.delete(`${base(objectType)}/fields/${fieldCode}`)
}

export type LayoutEntry = { fieldCode: string; sortOrder: number; colWidth: number }

export async function updateSectionLayout(
  objectType: string,
  sectionCode: string,
  entries: LayoutEntry[],
): Promise<void> {
  await api.put(`${base(objectType)}/sections/${sectionCode}/layout`, { entries })
}

export async function listAccessPolicies(objectType: string): Promise<AccessPolicy[]> {
  const res = await api.get<AccessPolicy[]>(`${base(objectType)}/access-policies`)
  return res.data
}

export async function createAccessPolicy(objectType: string, payload: AccessPolicyRequest): Promise<AccessPolicy> {
  const res = await api.post<AccessPolicy>(`${base(objectType)}/access-policies`, payload)
  return res.data
}

export async function updateAccessPolicy(objectType: string, id: number, payload: AccessPolicyRequest): Promise<AccessPolicy> {
  const res = await api.put<AccessPolicy>(`${base(objectType)}/access-policies/${id}`, payload)
  return res.data
}

export async function deleteAccessPolicy(objectType: string, id: number): Promise<void> {
  await api.delete(`${base(objectType)}/access-policies/${id}`)
}
